import { StorageKey } from '../../core/storage/storage-key';
import useSessionStorage from '../../core/storage/use-session-storage';

export function useKnowsHowToUse3dViewer() {
  const [knowsHowToUse3DViewer, setKnowsHowToUse3DViewer] = useSessionStorage(StorageKey.KnowsHowToUse3DViewer, false);

  return {
    knowsHowToUse3DViewer,
    setKnowsHowToUse3DViewer,
  };
}
